module.exports = __webpack_public_path__ + "static/media/me.4aaa47cf.JPG";